import React from "react";
import { FaInfoCircle } from "react-icons/fa";

export default function SpintaxHelp() {
  return (
    <details className="mt-2 group">
      <summary className="text-xs text-fuchsia-700 hover:text-fuchsia-900 cursor-pointer inline-flex items-center gap-1.5 select-none">
        <FaInfoCircle size={10} />
        <span className="underline-offset-2 group-hover:underline">How to use spintax in this message</span>
      </summary>
      <div className="mt-2 p-3 rounded border border-fuchsia-100 bg-fuchsia-50/60 text-xs text-slate-700 space-y-2">
        <p>
          Spintax sends a slightly different message to each recipient. Wrap alternatives in{" "}
          <code className="bg-white px-1 rounded border border-fuchsia-100">{`{a|b|c}`}</code> and Walytic
          picks one at random per send. This reduces the &quot;same message blasted to thousands&quot; signal
          that gets WhatsApp numbers banned.
        </p>
        <div>
          <p className="font-semibold text-slate-800 mb-1">Examples</p>
          <ul className="space-y-1 list-none pl-0">
            <li>
              <code className="bg-white px-1 rounded border border-fuchsia-100">{`{Hi|Hello|Hey}`} {`{{firstName}}`}, your order is ready.</code>
            </li>
            <li>
              <code className="bg-white px-1 rounded border border-fuchsia-100">{`{Thanks|Appreciate it|Cheers}`} for signing up to {`{{company}}`}!</code>
            </li>
            <li>
              <code className="bg-white px-1 rounded border border-fuchsia-100">Quick {`{question|update|note}`}: {`{can you|could you|would you mind sharing}`} your address?</code>
            </li>
          </ul>
        </div>
        <ul className="space-y-1">
          <li>Walytic picks one alternative from each <code>{`{ | }`}</code> group at send time, per recipient. You don&apos;t have to enable anything; just type the message and save.</li>
          <li>Variables like <code className="bg-white px-1 rounded border border-fuchsia-100">{`{{firstName}}`}</code> work alongside spintax — keep them outside the <code>{`{ | }`}</code> braces.</li>
          <li>Aim for 2–5 alternates per group. Past ~10, the deduplication benefit plateaus.</li>
          <li>Nesting works: <code className="bg-white px-1 rounded border border-fuchsia-100">{`{Hi|{Hello|Hey} there}`}</code> is valid.</li>
          <li>
            Line breaks are preserved inside groups, so you can spread a long alternate over several lines and put each <code>{`|`}</code> on its own line. For example:
            <pre className="mt-1 p-2 rounded bg-white border border-fuchsia-100 text-2xs whitespace-pre overflow-x-auto leading-snug">{`{Hi {{firstName}}, hope you're well.
Just checking in on your order.
|
Hey {{firstName}},
Quick update on your delivery.}`}</pre>
            Walytic still picks one whole alternate at random — the newlines inside it ship through to WhatsApp as part of the same bubble.
          </li>
        </ul>
        <p>
          <a
            href="https://walytic.com/help-center/spintax-message-variation"
            target="_blank"
            rel="noopener noreferrer"
            className="text-fuchsia-700 hover:text-fuchsia-900 underline"
          >
            Read the full spintax guide →
          </a>
        </p>
      </div>
    </details>
  );
}
